import { Alert } from '@ps/isp-web-component-library';
import React, { useEffect, useState } from 'react';

import { useSportsMyBetsWidget } from '../../../../../../../../model/index';

import styles from './CashOutError.scss';

interface Props {
  betId: string;
  error: string;
}

const CashOutError: React.FC<Props> = ({ error, betId }) => {
  const [isVisible, setVisible] = useState(true);
  const { widgetDispatch } = useSportsMyBetsWidget();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setVisible(false);
      widgetDispatch.cashOutClearError({ betId });
    }, 10000);

    return () => {
      clearTimeout(timeout);
    };
  }, [widgetDispatch, betId]);

  return isVisible ? (
    <div className={styles.container}>
      <Alert variant="passive" level="destructive">
        {error}
      </Alert>
    </div>
  ) : null;
};

export default CashOutError;
